import { Fragment } from 'react';
import { Chain } from '@ankr.com/chains-list';
import { Box } from '@mui/material';

import { NavLink } from 'uiKit/NavLink';
import { chainsRoutesConfig } from 'domains/chains/routes';

interface ISubChainLinksGeneratorProps extends ISSRChainsLinksGeneratorProps {
  rootChainID: Chain['id'];
}

const flatProtocolSubchains = (chains: Chain[]) =>
  chains.reduce<Chain[]>((acc, cur) => {
    acc.push(cur);
    acc.concat(cur.beacons || []);
    acc.concat(cur.opnodes || []);

    return acc;
  }, []);

const SubChainLinksGenerator = ({
  chains,
  rootChainID,
}: ISubChainLinksGeneratorProps) => {
  return (
    <>
      {chains.map(
        ({
          beacons = [],
          devnets = [],
          extenders = [],
          extensions = [],
          id,
          name,
          opnodes = [],
          signets = [],
          testnets = [],
        }) => {
          const subchains = flatProtocolSubchains([
            ...signets,
            ...testnets,
            ...devnets,
            ...extensions,
            ...extenders,
            ...beacons,
            ...opnodes,
          ]);

          return (
            <Fragment key={name}>
              <NavLink
                isRouterLink
                href={chainsRoutesConfig.chainDetails.generatePath(
                  rootChainID,
                  id,
                )}
              />
              {!!subchains.length && (
                <SubChainLinksGenerator
                  rootChainID={rootChainID}
                  chains={subchains}
                />
              )}
            </Fragment>
          );
        },
      )}
    </>
  );
};

interface ISSRChainsLinksGeneratorProps {
  chains: Chain[];
}

export const SSRChainsLinksGenerator = ({
  chains,
}: ISSRChainsLinksGeneratorProps) => {
  return (
    <Box id="chainList">
      {chains.map(
        ({
          beacons = [],
          devnets = [],
          extenders = [],
          extensions = [],
          id,
          name,
          signets = [],
          testnets = [],
        }) => (
          <Fragment key={name}>
            <NavLink
              isRouterLink
              href={chainsRoutesConfig.chainDetails.generatePath(id)}
            />
            <SubChainLinksGenerator
              rootChainID={id}
              chains={[
                ...testnets,
                ...devnets,
                ...signets,
                ...extensions,
                ...extenders,
                ...beacons,
              ]}
            />
          </Fragment>
        ),
      )}
    </Box>
  );
};
